import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useToast } from '../../hooks/useToast';

import { Button } from '../../components/ui/Button';
import { LoadingScreen } from '../../components/ui/LoadingScreen';
import fTitle from '../../utils/owner-portal/formatTitle';
import { escapeButtonLabel } from '../../utils/owner-portal/uiConstants';
import ReservationDetails from '../../sections/dashboard/reservation/ReservationDetails';
import { useReservationPopoverState } from '../../sections/dashboard/reservation/list/useReservationPopoverState';
import { useGetRTKQSingleReservationQuery } from '../../redux/rtkQuery/apiSlice';
import { safelyReadErrorMessage } from '../../utils/owner-portal/errorHandling';

// ----------------------------------------------------------------------

export default function ReservationLandingPage() {
  const { toast } = useToast();

  const { id } = useParams();

  const {
    data: reservationData,
    error: reservationError,
    isFetching,
    isSuccess,
    isError
  } = useGetRTKQSingleReservationQuery({ reservationId: id });

  useEffect(() => {
    if (isError) {
      toast({ title: safelyReadErrorMessage(null, reservationError), variant: 'destructive' });
    }
  }, [toast, isError, reservationError]);

  const popOverProps = useReservationPopoverState();

  if (isFetching) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Helmet>
        <title>{fTitle('Booking')}</title>
      </Helmet>

      <div className="mx-auto w-full max-w-7xl px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
        {isSuccess && (
          <div className="max-w-3xl">
            <ReservationDetails reservation={reservationData} {...popOverProps} />
          </div>
        )}

        <div className="mt-4 lg:hidden">
          <Button variant="ghost" asChild>
            <Link to="/">{escapeButtonLabel}</Link>
          </Button>
        </div>
      </div>

    </>
  );
}
